import React from "react"

import {
	Button,
	CircularProgress,
	DialogContent,
	DialogTitle,
	Grid,
	Typography
} from "@material-ui/core"

import { Alert } from "@material-ui/lab"

import { convertCentsInReals } from "@/utils/currencyFormatter"

import useStyles from "@/components/UpsellDialog/UpsellQuantityDialog/styles"

import { UpsellDetails } from "@/protocols/upsell"
import { UpsellQuantityType, UpsellQuantityInfo } from "@/protocols/planAddons"

type UpsellQuantityDialogWaitingPaymentContentProps = {
	upsellDetails: UpsellDetails
	upsellQuantityType: UpsellQuantityType
	selectedUpsellPlanAddon: UpsellQuantityInfo
}

const UpsellQuantityDialogWaitingPaymentContent: React.FC<UpsellQuantityDialogWaitingPaymentContentProps> = (props) => {
	const {
		upsellDetails,
		upsellQuantityType,
		selectedUpsellPlanAddon
	} = props

	const classes = useStyles()

	const getUpsellContent = () => {
		const upsellTypeToContent: Record<UpsellQuantityType, {
			additionalName: string
		}> = {
			user: {
				additionalName: "Atendentes adicionais"
			},
			voice_call_minutes: {
				additionalName: "Minutos de ligações adicionais"
			}
		}

		return upsellTypeToContent[upsellQuantityType]
	}

	const upsellContent = getUpsellContent()

	return (
		<Grid
			container
			direction="column"
			className={classes.fullDialog}
		>
			<Grid
				item
			>
				<DialogTitle>
					<Grid
						container
						direction="column"
						spacing={2}
					>
						<Grid
							item
						>
							<Typography variant="h3" className={classes.dialogTitle}>
								Estamos quase lá!
							</Typography>
						</Grid>
					</Grid>
				</DialogTitle>
			</Grid>
			<Grid
				item
			>
				<DialogContent className={classes.dialogContent}>
					<Grid
						container
						direction="column"
						spacing={4}
					>
						<Grid item>
							<Typography className={classes.dialogDescription}>
								🎉 Perfeito! Você está prestes a ativar seu plano!
							</Typography>
						</Grid>
						<Grid item>
							<Grid container direction="column" spacing={1}>
								<Grid item>
									<Typography variant="h6" className={classes.planAddonsInformationText}>
										Plano selecionado:
									</Typography>
								</Grid>
								<Grid item>
									<Typography variant="body1">
										<strong>Nome:</strong> {upsellContent.additionalName}
									</Typography>
								</Grid>
								<Grid item>
									<Typography variant="body1">
										<strong>Quantidade:</strong> {selectedUpsellPlanAddon.quantity}
									</Typography>
								</Grid>
								<Grid item>
									<Typography variant="body1">
										<strong>Preço:</strong> {convertCentsInReals(selectedUpsellPlanAddon.priceInCents)}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Typography className={classes.dialogDescription}>
								Realize o pagamento abaixo para concluir a ativação do plano:
							</Typography>
						</Grid>
						<Grid item>
							<Grid container spacing={2}>
								<Grid item xs={10}>
									<Button
										variant="contained"
										className={classes.dialogActionPrimaryButton}
										href={upsellDetails.paymentLink ?? undefined}
										target="_blank"
										fullWidth
									>
										Abrir página de pagamento
									</Button>
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Alert
								severity="info"
								icon={<CircularProgress />}
							>
								Estamos aguardando a confirmação do pagamento. Assim que ele for aprovado, seu plano será ativado automaticamente.
							</Alert>
						</Grid>
					</Grid>
				</DialogContent>
			</Grid>
		</Grid>
	)
}

export default UpsellQuantityDialogWaitingPaymentContent
